import { useQuery } from '@tanstack/react-query';

export interface TaxExemption {
  code: string;
  libelle: string;
  /** Traduction en français courant, quand le rattachement ne fait pas débat. */
  aide?: string | null;
}

interface Reponse {
  exemptions: TaxExemption[];
  /** Le motif déjà retenu pour un compte, par libellé de compte normalisé. */
  par_compte: Record<string, string>;
}

/**
 * Les codes d'exonération de TVA (les 19 de l'article 261 du CGI), et la
 * mémoire de ce qui a déjà été choisi compte par compte.
 *
 * Le choix du motif est fiscal, donc humain — mais il ne se prend qu'une fois
 * par compte d'imputation : « sur le compte de services bancaires, c'est le
 * 261 C-1 ». Ensuite l'application le rejoue.
 *
 * Pas de cache côté client : un motif choisi sur la facture précédente doit
 * apparaître sur la suivante, y compris dans la même session.
 */
export function useTaxExemptions() {
  const { data, isLoading } = useQuery({
    queryKey: ['reference-data', 'tax-exemptions'],
    queryFn: async (): Promise<Reponse> => {
      const res = await fetch('/api/reference-data/tax-exemptions', { credentials: 'include' });
      if (!res.ok) return { exemptions: [], par_compte: {} };
      return res.json();
    },
  });
  return {
    exemptions: data?.exemptions ?? [],
    parCompte: data?.par_compte ?? {},
    chargement: isLoading,
  };
}

/** Même normalisation que côté serveur : casse et espaces mis à part. */
export function exonerationConnue(
  parCompte: Record<string, string>,
  compte: string | null | undefined,
): string | null {
  if (!compte) return null;
  return parCompte[compte.trim().replace(/\s+/g, ' ').toLowerCase()] ?? null;
}
